import React from "react";
import { Box, Typography } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { AccountHeaderTitle } from "../../components/AccountHeader";
import { useFallbackUrl } from "../../components/AppHistory";
import { Crumb } from "../../components/Breadcrumb";
import { ViewSelector } from "../../features/Financials/components/ViewSelector";
import { ModalRoutes } from "../ModalRoutes";
import { NestedRoutes } from "../NestedRoutes";
import { PageComponent } from "../routes";
import { SuccessNotification } from "../../features/Search/components/SuccessNotification";

export const FinancialsPage: PageComponent = ({
  routes,
  modals,
  fallbackUrl,
}) => {
  useFallbackUrl(fallbackUrl);
  const { accountNumber } = useParams();

  return (
    <>
      <Helmet>
        <title>{`${accountNumber} - Account Financials`}</title>
      </Helmet>

      <AccountHeaderTitle>
        <Typography variant="h4" color="textPrimary">
          Financials
        </Typography>
      </AccountHeaderTitle>

      {/* Breadcrumb */}
      <Crumb label="Financials" />

      <ModalRoutes modals={modals} />

      {/* Subviews */}
      <Box display="flex" flexDirection="column" px={3} py={2}>
        <SuccessNotification mb={2} />
        <Box mb={2.5}>
          <Typography variant="body1" color="textPrimary">
            View
          </Typography>
          <ViewSelector />
        </Box>
        <Box display="flex" width={1}>
          <NestedRoutes routes={routes} />
        </Box>
      </Box>
    </>
  );
};
